import { render, staticRenderFns } from "./CCMRecords.vue?vue&type=template&id=480cfb3b&scoped=true"
import script from "./CCMRecords.vue?vue&type=script&lang=js"
export * from "./CCMRecords.vue?vue&type=script&lang=js"
import style0 from "./CCMRecords.vue?vue&type=style&index=0&id=480cfb3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480cfb3b",
  null
  
)

export default component.exports